import { render, staticRenderFns } from "./ButtonQuickpick.vue?vue&type=template&id=0b8de85f&scoped=true"
import script from "./ButtonQuickpick.vue?vue&type=script&lang=js"
export * from "./ButtonQuickpick.vue?vue&type=script&lang=js"
import style0 from "./ButtonQuickpick.vue?vue&type=style&index=0&id=0b8de85f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8de85f",
  null
  
)

export default component.exports